import React from 'react'
import PropTypes from 'prop-types'

// `flex!` overrides Bootstrap reboot `header { display: block }` which beats
// Tailwind utilities in the cascade (cf. project feedback note on BS vs TW v4).
const HEADER_CLASS = 'tw:flex! tw:items-center tw:gap-2.5 tw:p-6 '
  + 'tw:border-b tw:border-solid tw:border-gray-300'

// `!` forces Tailwind over Bootstrap heading reset; `truncate` keeps the
// Heading on one line when section names overflow the drawer width.
const TITLE_CLASS = 'tw:text-lg! tw:font-medium! tw:m-0! tw:text-gray-900! '
  + 'tw:leading-none! tw:flex-1 tw:min-w-0 tw:truncate'

// `rounded-full!` overrides Bootstrap `$enable-rounded: false` (zeroes radius).
const CLOSE_BUTTON_CLASS = 'tw:inline-flex tw:items-center tw:justify-center '
  + 'tw:size-8 tw:rounded-full! tw:bg-white tw:border-0 tw:cursor-pointer '
  + 'tw:text-gray-900 tw:hover:bg-gray-100 tw:focus-visible:outline-none'

// The `back` variant puts a left chevron before the title.
// The `dismiss` variant puts a close cross at the right (title owns `flex-1`).
const CLOSE_ICON = { back: 'fa-chevron-left', dismiss: 'fa-times' }

const renderHeading = children => {
  if (typeof children === 'string')
    return <h2 className={TITLE_CLASS} title={children}>{children}</h2>
  return children
}

const renderClose = (onClose, closeVariant) => {
  if (!onClose)
    return null
  return (
    <button
      aria-label="Fermer le panneau"
      className={CLOSE_BUTTON_CLASS}
      type="button"
      onClick={onClose}
    >
      <i aria-hidden="true" className={`fas ${CLOSE_ICON[closeVariant]} tw:text-xl`} />
    </button>
  )
}

const DrawerHeader = ({ children, className, onClose, closeVariant }) => (
  <header className={`${HEADER_CLASS} ${className}`}>
    {closeVariant === 'dismiss' ? (
      <>
        {renderHeading(children)}
        {renderClose(onClose, closeVariant)}
      </>
    ) : (
      <>
        {renderClose(onClose, closeVariant)}
        {renderHeading(children)}
      </>
    )}
  </header>
)

DrawerHeader.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  closeVariant: PropTypes.oneOf(['back', 'dismiss']),
  onClose: PropTypes.func
}

DrawerHeader.defaultProps = {
  className: '',
  closeVariant: 'back',
  onClose: null
}

export default DrawerHeader
